import { color, mediaQueries, space, breakpoints } from "./styles";
import {
  getEventIds,
  getVisitIds,
  getOpenPassIds,
  getTourPerformanceIds,
  getTourTimeslotMonths,
  getTourTimeslotDates,
  getPerformanceIds,
  getTimeslotDateIds,
  getMonthTimeslotIds,
  getTimeslotMonths,
  getTimeslotDates,
  toTimeslotDateId,
  mergeState,
  getProductTypeFromLocalStorage,
  storeProductTypeToLocalStorage,
  findDayRange,
  updateUnselectedItemHelper,
  getRevenueData,
  getPotentialRevenueData,
  AllProductSummariesHelper,
  TranslationModule,
  round,
} from './util';

import { PriceModeEnum, ReportProductTypeEnum, NO_TOUR, NO_TOUR_ID, TOUR_REPORT_LEVEL_ENUM } from './constants';

import { buildSaleHistoryData, getSaleHistoryViews } from './saleHistoryHelper';

const DashboardStyles = {
    color,
    mediaQueries,
    space,
    breakpoints,
};

const {
  getTranslatedName,
  translateDashboardData
} = TranslationModule;
export {
  DashboardStyles,
  getPerformanceIds,
  getTimeslotDateIds,
  getMonthTimeslotIds,
  getTimeslotMonths,
  getTimeslotDates,
  toTimeslotDateId,
  mergeState,
  getProductTypeFromLocalStorage,
  storeProductTypeToLocalStorage,
  findDayRange,
  updateUnselectedItemHelper,
  PriceModeEnum,
  ReportProductTypeEnum,
  NO_TOUR,
  NO_TOUR_ID,
  TOUR_REPORT_LEVEL_ENUM,
  AllProductSummariesHelper,
  getRevenueData,
  getPotentialRevenueData,
  getTranslatedName,
  translateDashboardData,
  buildSaleHistoryData,
  getSaleHistoryViews,
  getEventIds,
  getVisitIds,
  getOpenPassIds,
  getTourPerformanceIds,
  getTourTimeslotMonths,
  getTourTimeslotDates,
  round,
  TranslationModule,
};
